import axios from 'axios';

export interface DemoJob {
    id: string;
    name: string;
    location?: string;
    url?: string;
    is_connected: boolean;
}

export interface DemoBatchInfo {
    id: string | null;
    created_at: string | null;
    created_by: string | null;
    object_count: number;
}

export interface DemoPreflightResponse {
    available_jobs: DemoJob[];
    connected_jobs: string[];
    can_create_demo: boolean;
    has_demo_data: boolean;
    demo_batch_info: DemoBatchInfo;
}

export interface DemoBatch {
    id: string;
    label: string;
    created_at: string;
    created_by: string | null;
    object_count: number;
}

export interface DemoStatusResponse {
    has_demo_data: boolean;
    batches: DemoBatch[];
}

export interface DemoSeedRequest {
    job_ids: string[]; // Exactly 1 job ID required for optimal demo experience
}

export interface DemoTaskResponse {
    message: string;
    task_id: string;
}

/**
 * Check if demo data can be created (preflight check)
 */
export const getDemoPreflight = async (): Promise<DemoPreflightResponse> => {
    const response = await axios.get(
        `${process.env.REACT_APP_API_URL}demo/preflight/`
    );
    return response.data;
};

/**
 * Create demo data
 */
export const createDemoData = async (request: DemoSeedRequest): Promise<DemoTaskResponse> => {
    const response = await axios.post(
        `${process.env.REACT_APP_API_URL}demo/seed/`,
        request
    );
    return response.data;
};

/**
 * Remove all demo data
 */
export const flushDemoData = async (): Promise<DemoTaskResponse> => {
    const response = await axios.post(
        `${process.env.REACT_APP_API_URL}demo/flush/`
    );
    return response.data;
};

/**
 * Get demo data status
 */
export const getDemoStatus = async (): Promise<DemoStatusResponse | null> => {
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}demo/status/`
        );
        return response.data;
    } catch (error: any) {
        console.error('Error fetching demo status', error);
        return null;
    }
}; 